<template>
  <div>
    <div class="row mt-4">
      <div class="col-md-12 col-12 form-field">
        <!--        SUPPLIER SECTION-->
        <div v-if="!isSupplierNameLoaded" class="mt-4 mb-4">
          <strong class="title-style"> Supplier Details </strong>
          <div class="mb-2" >
            <div class="title required-field mt-2 mb-3">
              <span>8. </span>
              <span>Have you selected a supplier?</span>
            </div>
            <div class="d-inline" :key="index" v-for="(radio,index) in CONSTANTS.ONE_INTAKE_RADIO_BOOLEAN">
              <label class="row no-gutters ml-3">
                <input
                    class="vertical-radio"
                    :key="index"
                    type="radio"
                    name="isSupplierKnown"
                    v-model="isSupplierKnown"
                    :value="radio.value"
                    v-validate="'required'"
                    :disabled="supplierOnboardRequestData.duplicateForm"
                > {{radio.text}}</label>
            </div>
            <div
                class="text-danger input-error-text"
                v-if="errors.has('isSupplierKnown')"
            >This field is required</div>
          </div>
          <div v-if="!isSupplierKnown && isSupplierKnown !== undefined" class="form-text text-muted">
            A Supplier Engagement team member will contact you to help find an appropriate supplier. Please click Next to continue.
          </div>

          <div class="mt-4" v-show = "!disableIfSupplierHelpNeeded">
            <div class="row border-outline">
              <strong class="border-text">Supplier contact details</strong>

              <div class="mt-3">
                <div class="col-12">
                  <div>
                    <div class="title required-field mt-2">
                      <span>8a. </span>
                      <span class="mr-1">Supplier name</span>
                    </div>
                    <span class="font-italic">{{supplierNameHelpText}}</span>
                  </div>

                  <div class="mb-4">
                    <supplier-auto-complete
                    ref="supplierAutoComplete"
                    :isRequired="true"
                    :isOneInTakeForm="true"
                    name="supplierOnboardRequestData.supplierName"
                    :currentSelection="supplierOnboardRequestData.supplierName"
                    :isDisabled="supplierOnboardRequestData.duplicateForm || disableIfSupplierHelpNeeded || isSupplierNameLoaded"
                    @onItemSelected="assignSupplierName"
                    :key="supplierAutoCompleteKey"
                    @supplierNameSelectedFromDropdown="isSupplierNameSelected"
                    @OnBlurAutoComplete="showSupplierNameWarning"
                    @newNameFieldEvent="changeNameFieldEvent"
                    />
                    <span class="text-danger font-italic">{{supplierResellerHelpText}}</span>
                  </div>
                  <span
                      class="text-danger input-error-text"
                      v-if="errors.has('supplierOnboardRequestData.supplierName')"
                  >Supplier name is required</span>
                </div>

            <div class="col-12" v-if="supplierNameSelectedFromDropdown===false && nameFieldEventOccured && showSimilarSupplierNames && supplierOnboardRequestData.supplierName && supplierOnboardRequestData.supplierName.length && !isSupplierLoading">
              <span class="font-italic">{{supplierSimilarNamesHelpText}}</span><br>
               <div class="d-flex flex-row flex-wrap"  v-if="showAllSupplierNames">
                 <div class="ml-2 supplier-name" v-for="supplier of similarSupplierNames" :key="supplier.name" >
                <p @click="onSupplierSelected(supplier.name)" class="font-italic"><u>{{supplier.name}}</u></p>
              </div>
              </div>
              <div class="d-flex flex-row flex-wrap"  v-else>
                  <div class="ml-2 supplier-name" v-for="supplier of similarSupplierNames.slice(0,5)" :key="supplier.name">
                  <p @click="onSupplierSelected(supplier.name)" class="font-italic"><u>{{supplier.name}}</u></p>
                  </div>
                  <div class="ml-2 supplier-name" v-if="similarSupplierNames.length > 5" @click="toggleShowAllSupplierNames">
                  <p class="font-italic"><u>+{{similarSupplierNames.length - 5}}</u></p>
                  </div>  
              </div>
              </div>

                <div class="col-12">
                  <div class="title pt-2">
                    <span>8b. </span>
                    <span>URL for supplier’s website</span>
                  </div>
                  <div class="mb-4 pb-3">
                    <input
                        class="form-control w-100 mt-1"
                        v-validate="'url'"
                        name="supplierOnboardRequestData.supplierWebsite"
                        v-model.lazy="supplierOnboardRequestData.supplierWebsite"
                        :disabled="supplierOnboardRequestData.duplicateForm || disableIfSupplierHelpNeeded"
                        autocomplete="chrome-off"
                    >
                    <span
                        class="text-danger input-error-text"
                        v-if="errors.has('supplierOnboardRequestData.supplierWebsite')"
                    >Website should be of a valid format</span>
                  </div>
                </div>

                <div class="row col-12 m-0 p-0">
                  <div class="col-md-6">
                    <div class="title required-field">
                      <span>8c. </span>
                      <header-with-tooltip
                          :tooltip-text="`Not entering correct supplier account representative information could delay ticket being completed.`"
                          :isHTML="true"
                          :show-icon="true">
                        <span class="mr-1">Name of your contact at {{supplierName }}</span>
                      </header-with-tooltip>
                    </div>
                    <div class="mb-4">
                      <input
                          class="form-control w-100 mt-1"
                          name="supplierOnboardRequestData.supplierContactName"
                          v-model="supplierOnboardRequestData.supplierContactName"
                          :disabled="disableIfSupplierHelpNeeded"
                          autocomplete="chrome-off"
                          v-validate="'required'"
                          data-vv-validate-on="input"
                      >
                      <span
                          class="text-danger input-error-text"
                          v-if="errors.has('supplierOnboardRequestData.supplierContactName')"
                      >Supplier contact name is required</span>
                    </div>
                  </div>

                  <div class="col-md-6 mt-1 mr-0">
                    <div class="title">
                      <span>8d. </span>
                      <span>Supplier contact role</span>
                    </div>
                    <div class="item mb-4 select-style">
                      <model-list-select
                          :list="supplierContactRoleOptions"
                          :optionValue="'value'"
                          :optionText="'text'"
                          name="supplierOnboardRequestData.supplierContactRole"
                          v-model="supplierOnboardRequestData.supplierContactRole"
                          :isDisabled="supplierOnboardRequestData.duplicateForm || disableIfSupplierHelpNeeded"
                          autocomplete="chrome-off"
                          class="" />
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="title required-field pt-2">
                      <span>8e. </span>
                      <header-with-tooltip
                          :tooltip-text="`Not entering correct supplier account representative information could delay ticket being completed.`"
                          :isHTML="true"
                          :show-icon="true">
                        <span class="mr-1">Supplier contact email</span>
                      </header-with-tooltip>
                    </div>
                    <div class="mb-4">
                      <input
                          class="form-control w-100 mt-1"
                          v-validate="'required|email'"
                          name="supplierOnboardRequestData.supplierContactEmail"
                          v-model.lazy="supplierOnboardRequestData.supplierContactEmail"
                          data-vv-validate-on="input"
                          :disabled="disableIfSupplierHelpNeeded"
                          autocomplete="chrome-off"
                      >
                      <span
                          class="text-danger input-error-text"
                          v-if="errors.has('supplierOnboardRequestData.supplierContactEmail')"
                      >Supplier contact email is required and must be of valid email format</span>
                    </div>
                  </div>

                <div class="col-md-6 mt-1">
                  <div class="title required-field pt-2">
                    <span>8f. </span>
                    <header-with-tooltip
                        :tooltip-text="`Enter the country where the supplier services will be provided from.`"
                        :isHTML="true"
                        :show-icon="true">
                      <span class="mr-1">Supplier country</span>
                    </header-with-tooltip>
                  </div>
                  <div class="mb-4 select-style">
                    <model-list-select
                        :list="generateSortedSupplierCountryList"
                        :optionValue="'value'"
                        :optionText="'text'"
                        id="supplierOnboardRequestData.supplierCountry"
                        name="supplierOnboardRequestData.supplierCountry"
                        v-model="countryValue"
                        v-validate="isSupplierKnown ? 'required' : ''"
                        autocomplete="nope"
                        data-vv-validate-on="input"
                        @input="setCountryText"
                        :isDisabled="supplierOnboardRequestData.duplicateForm || disableIfSupplierHelpNeeded || isICRequest"
                    />
                    <span
                        class="text-danger input-error-text"
                        v-if="errors.has('supplierOnboardRequestData.supplierCountry')"
                    >Supplier country is required</span>
                  </div>
                </div>

                  <div class="col-md-6" v-if="isCountryUS && isSupplierKnown">
                    <div class="title required-field mt-2 mb-3">
                      <span>8g. </span>
                      <span>Did you consider a diverse supplier?</span>
                    </div>
                    <div class="d-inline" :key="index" v-for="(radio,index) in CONSTANTS.ONE_INTAKE_RADIO_BOOLEAN">
                      <label class="row no-gutters ml-3">
                        <input
                            class="vertical-radio"
                            :key="index"
                            type="radio"
                            name="supplierOnboardRequestData.diverseSupplierConsidered"
                            v-model="supplierOnboardRequestData.diverseSupplierConsidered"
                            :value="radio.value"
                            v-validate="isCountryUS && isSupplierKnown ? 'required' : ''"
                            :disabled="supplierOnboardRequestData.duplicateForm"
                        > {{radio.text}}</label>
                    </div>
                    <div
                        class="text-danger input-error-text"
                        v-if="errors.has('supplierOnboardRequestData.diverseSupplierConsidered')"
                    >This field is required</div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>


<!--        RESELLER SECTION-->
        <div v-if="isProcurementCategoryTechnology && isSupplierKnown">
          <strong class="title-style"> Reseller Details </strong>
          <div class="mb-12" >
            <div class="title mt-2 mb-3" :class="[isICRequest ? 'disabled-title' : 'required-field']">
              <span>9. </span>
              <header-with-tooltip
                  :tooltip-text="`Select yes if the purchase will be made through a value added reseller. If yes, make sure to use the manufacturer name (not the reseller name) for the supplier information on this form.`"
                  :isHTML="true"
                  :show-icon="true"
                  >
              <span class="mr-1">Are you buying this technology through a reseller?</span>
              </header-with-tooltip>
              <span v-if="isICRequest" class="notification-text font-italic"><br>{{CONSTANTS.warningMessageForICDisabledQuestions}}</span>
            </div>

            <div class="d-inline" :key="index" v-for="(radio,index) in CONSTANTS.ONE_INTAKE_RADIO_OPTIONS">
              <label class="row no-gutters ml-3" :class="[isICRequest ? 'disabled-title' : '']">
                <input
                    class="vertical-radio"
                    :key="index"
                    type="radio"
                    name="supplierOnboardRequestData.technologyFromReseller"
                    v-model="supplierOnboardRequestData.technologyFromReseller"
                    :value="radio.text"
                    v-validate="isProcurementCategoryTechnology && !isICRequest ? 'required' : ''"
                    :disabled="supplierOnboardRequestData.duplicateForm || isICRequest"
                > {{radio.displayText}}
              </label>
            </div>

            <div
                class="text-danger input-error-text"
                v-if="errors.has('supplierOnboardRequestData.technologyFromReseller')"
            >This field is required</div>

          </div>

          <div class="mt-4" v-show = "isTechnologyFromReseller">
            <div class="row border-outline">
              <strong class="border-text">Reseller details</strong>
                <div class="mt-3 col-12">
                  <div >
                    <div class="title required-field mt-2">
                      <span>9a. </span>
                      <span class="mr-1">Reseller name</span>
                    </div>
                  </div>
                  <span class="font-italic">{{resellerNameHelpText}}</span>
                    <div>
                      <div class="select-style">
                        <model-list-select
                            :list="generateSortedResellerList"
                            :optionValue="'value'"
                            :optionText="'text'"
                            id="supplierOnboardRequestData.resellerName"
                            name="supplierOnboardRequestData.resellerName"
                            v-validate="isTechnologyFromReseller?'required':''"
                            data-vv-validate-on="input"
                            v-model="supplierOnboardRequestData.resellerName"
                            @input="resellerValidation()"
                            :isDisabled="supplierOnboardRequestData.duplicateForm"
                        />
                        <span class="text-danger font-italic" v-if="errors.has('supplierOnboardRequestData.resellerName')">Reseller name is required</span><br>
                        <span class="text-danger font-italic"  v-if="isSupplierResellerNameEqual" >{{resellerSameAsSupplierErrorText}}</span>
                    </div>
                    </div>
                  <br>
                  <div class="mb-3">
                    <input type="checkbox" @click="showModelToRedirectToMail($event)" :disabled="supplierOnboardRequestData.duplicateForm">
                    <span class="title ml-2"> I do not see my Reseller in the list</span>
                  </div>
                </div>
            </div>
          </div>
        </div>
<!--        End of reseller section-->
          </div>
        </div>

        <div class="float-md-right mt-4 pr-0">
          <button class="btn-container flat-btn gray-btn close-btn btn mx-2 my-3" @click="navigateToHome">Cancel</button>
          <button class="btn-container flat-btn gray-btn close-btn btn mx-2 my-3" @click="validateAndSetDraftRequest">Save Draft</button>
          <button class="btn-container btn flat-btn primary-blue-btn ml-2 my-3" @click="validateAndSetCurrentTab('AdditionalDetails')">Next</button>
        </div>

      </div>
</template>

<script>
import {mapGetters, mapMutations} from "vuex";
import supplierRequestMixin from "@/mixins/supplierRequestMixin";
import {ModelListSelect} from "vue-search-select"
import SupplierAutoComplete from "@/components/SupplierAutoComplete";
import HeaderWithTooltip from "@/components/HeaderWithTooltip";
import api from "@/api"
import {extract,token_set_ratio} from "fuzzball"
import swal from "sweetalert2";
import CONSTANTS from "@/store/constants";

export default {
  name: "SupplierInformation",
  mixins: [supplierRequestMixin],
  components: {ModelListSelect, SupplierAutoComplete, HeaderWithTooltip},
  data() {
    return {
      /* backend supports variable=needHelpWithSupplier. Added reverse variable to track locally changes on this page */
      isSupplierKnown: undefined,
      countryValue:'',
      supplierNameHelpText: 'Start typing the name of the supplier you want to work with. The system will provide suggestions from existing suppliers’ data. If you do not see your supplier suggested, type in the complete legal name and submit.',
      resellerNameHelpText: "Start typing the name of the reseller you want to work with. The system will provide suggestions from existing resellers' data. If you do not see your reseller suggested, select the checkbox below to be redirected.",
      supplierAutoCompleteKey: 0,
      supplierResellerHelpText: 'Please provide the name of the manufacturer, not the reseller',
      supplierNameSelectedFromDropdown : undefined,
      nameFieldEventOccured :undefined,
      supplierSimilarNamesHelpText : 'Did you mean one of the following?',
      similarSupplierNames: [],
      showAllSupplierNames: false,
      isSupplierLoading: false,
      resellerAutoCompleteKey:0,
      resellerSameAsSupplierErrorText: 'Reseller name cannot be the same as supplier name. Under supplier name, please include the name and contact information of the manufacturer.',
      resellerList: [],
      isSupplierResellerNameEqual: false
    }
  },
  created() {
    window.scrollTo(0,0)
    if(this.supplierOnboardRequestData.needHelpWithSupplier !== undefined) {
      this.isSupplierKnown = !this.supplierOnboardRequestData.needHelpWithSupplier
    }
    this.setCountryValue()
  },
  mounted() {
    this.disableAutofill('supplierOnboardRequestData.supplierCountry')
  },
  computed: {
    ...mapGetters(['supplierOnboardRequestData','isSupplierNameLoaded','supplierContactRoleOptions',"adminDataList","supplierCountryList","suppliersNameList","resellerContactRoleOptions"]),
    validateIfRequired() {
      return this.isSupplierKnown ? 'required-field': ''
    },
    disableIfSupplierHelpNeeded() {
      return !this.isSupplierKnown
    },
    supplierName() {
      if(this.supplierOnboardRequestData.supplierName && this.$route.query.vendorId) {
        return this.supplierOnboardRequestData.supplierName
      } else{
        return "supplier"
      }
    },
    generateSortedSupplierCountryList(){
      return [...this.supplierCountryList].sort((a,b) => a.text.localeCompare(b.text))
    },
    showSimilarSupplierNames(){
      return this.similarSupplierNames.length > 0
    }, 
    isSupplierFullMatch(){
      // If the supplier name input is a 100% match, then we don't need to show the similar names
      return this.similarSupplierNames && this.similarSupplierNames.length > 0 && this.similarSupplierNames.find(supplier => supplier.name.toLowerCase() === this.supplierOnboardRequestData.supplierName.toLowerCase() && supplier.score == 100)
    },
    generateSortedResellerList(){
      return [...this.resellerList].sort((a,b)=> a.value.localeCompare(b.value))
    },
  },
  watch: {
    isSupplierKnown(val) {
      this.supplierOnboardRequestData.needHelpWithSupplier = !val
      if(!val) {
        delete this.supplierOnboardRequestData.supplierName
        delete this.supplierOnboardRequestData.supplierWebsite
        delete this.supplierOnboardRequestData.supplierContactName
        delete this.supplierOnboardRequestData.supplierContactRole
        delete this.supplierOnboardRequestData.supplierContactEmail
        delete this.supplierOnboardRequestData.supplierCountry
        delete this.supplierOnboardRequestData.recommendedByGovernment
        delete this.supplierOnboardRequestData.onBehalfOfAutodeskCustomer
        delete this.supplierOnboardRequestData.anyRelationshipWithAutodesk
        this.supplierOnboardRequestData.diverseSupplierConsidered = undefined
        this.supplierAutoCompleteKey++
        this.supplierOnboardRequestData.resellerName = ""
        this.$nextTick(() => {
          this.$set(this.$store.state.supplierOnboardRequestData, 'technologyFromReseller', undefined);
        });
      }else{
        if(this.isICRequest) {
          this.supplierOnboardRequestData.supplierCountry = this.supplierOnboardRequestData.supplierLocated;
        }else{
          delete this.supplierOnboardRequestData.supplierCountry
        }
      }
      this.setCountryValue()
      this.errors.clear()
    },
    isTechnologyFromReseller:{
      immediate:true,
      handler(val){
        if(!val){
          delete this.supplierOnboardRequestData.resellerName;
          this.isSupplierResellerNameEqual = false;
        }
        else{
          // populate list using API only when 9a is yes (reseller is known)
          this.getResellerList();
        }
      }
    }
  },
  methods: {
    ...mapMutations(['setCurrentTab']),
    async getResellerList(){
      //call api
      try{
        let resellerResponse = await api.getResellerFromCoreCompanyTable();
        if(resellerResponse.data.result){
          let uniqueResellerList = [];
          resellerResponse.data.result.forEach((item) => {
            // Check if the item's u_vendor_parent property exists in uniqueResellerList
            let isResellerExist = uniqueResellerList.find(reseller => reseller.u_vendor_parent.trim().toLowerCase() === item.u_vendor_parent.trim().toLowerCase());
            // If the reseller doesn't exist, add it to the uniqueResellerList
            if (!isResellerExist) {
              uniqueResellerList.push(item);
            }
          });

          // Transform uniqueResellerList into resellerDataList format
          let resellerDataList = uniqueResellerList.map(reseller => ({"value": reseller.u_vendor_parent, "text": " " + reseller.u_vendor_parent + " "}));

          this.resellerList = resellerDataList;
        }
      }catch{
        this.setErrorMessage(CONSTANTS.ERROR_MESSAGE)
      }
    },
    setCountryValue(){
      let supplierCountry = this.supplierOnboardRequestData.supplierCountry;
      this.supplierOnboardRequestData.supplierCountry = supplierCountry === 'UK' ? 'United Kingdom' : supplierCountry === 'US' ? 'United States' : supplierCountry;
      let country = this.supplierCountryList.find(country => country.text === this.supplierOnboardRequestData.supplierCountry)
      this.countryValue = country ? country.value : ''
    },
    setCountryText(index) {
      this.supplierOnboardRequestData.supplierCountry = this.getTextValue(this.supplierCountryList, index)
    },
    assignSupplierName(event){
        this.supplierOnboardRequestData.supplierName = event.filteredName
        this.resellerValidation()
    },
    resellerValidation() {

      const supplierName = this.supplierOnboardRequestData.supplierName;
      const resellerName = this.supplierOnboardRequestData.resellerName;

      this.isSupplierResellerNameEqual = ((supplierName && supplierName.length > 0) && (resellerName && resellerName.length > 0)) && (supplierName.trim().toLowerCase() === resellerName.trim().toLowerCase());
    },
    validateAndSetCurrentTab(tab) {
      if(this.isSupplierResellerNameEqual){
        this.$validator.validateAll()
        window.scrollTo(0,0)
      }
      else {
        this.$validator.validateAll().then((result) => {
          if(result) {
            this.setCurrentTab(tab)
          } else {
            window.scrollTo(0,0)
          }
        })
      }
    },
    validateAndSetDraftRequest() {
      this.$validator.validateAll().then((result) => {
        if(result) {
          this.saveSupplierOnboardRequest(true)
        } else {
          window.scrollTo(0,0)
        }
      })
    },
    isSupplierNameSelected(value){
      this.supplierNameSelectedFromDropdown = value  
    },
    showSupplierNameWarning(){
      if(!this.supplierNameSelectedFromDropdown){
        this.nameFieldEventOccured = true  
        this.showAllSupplierNames = false
        this.similarSupplierNames = []
        this.isSupplierLoading = true
        if(this.supplierOnboardRequestData.supplierName && this.supplierOnboardRequestData.supplierName.length > 0)
        {
          this.getSimilarSupplierNamesByThreshold()
        }
      }
    },
    changeNameFieldEvent(value)
    {
      this.nameFieldEventOccured = value
      this.showAllSupplierNames = false
    },
    getSimilarSupplierNamesByThreshold(){ 
      const supplierList = this.suppliersNameList
      const searchTerm = this.supplierOnboardRequestData.supplierName

      const thresholdResults = extract(searchTerm, supplierList, {cutoff: this.CONSTANTS.SUPPLIER_NAME_THRESHOLD,scorer : token_set_ratio})
      if (thresholdResults.length == 0)
      {
        this.getTopThreeSupplierNames(searchTerm)
      }
      else
      {
        this.similarSupplierNames = thresholdResults.map(result => {
          return {
            name: result[0],
            score: result[1]
          }
        })
        // remove duplicates
        this.similarSupplierNames = this.similarSupplierNames.filter((result, index, self) =>
          index === self.findIndex((t) => (
            t.name === result.name
          ))
        )
        this.similarSupplierNames = this.similarSupplierNames.slice(0,10)
        this.sortSimilarNamesResult()
        this.isSupplierLoading = false
      }
    },
    getTopThreeSupplierNames(searchTerm){
      const supplierList = this.suppliersNameList
      const topThreeResults = extract(searchTerm, supplierList, {limit: 3, scorer : token_set_ratio})
      this.similarSupplierNames = topThreeResults.map(result => {
        return {
          name: result[0],
          score: result[1]
        }
      })
      // remove duplicates

      this.similarSupplierNames = this.similarSupplierNames.filter((result, index, self) =>
        index === self.findIndex((t) => (
          t.name === result.name
        ))
      )
      this.sortSimilarNamesResult()
      this.isSupplierLoading = false
    },
    sortSimilarNamesResult()
    {
      const customComparator = (a, b) => {
          if (a.score > b.score) return -1;
          if (a.score < b.score) return 1;
          
          // If similarity scores are equal, prioritize words starting with the input
          if (a.name.toLowerCase().startsWith(this.supplierOnboardRequestData.supplierName.toLowerCase()) && !b.name.toLowerCase().startsWith(this.supplierOnboardRequestData.supplierName.toLowerCase())) return -1;
          if (!a.name.toLowerCase().startsWith(this.supplierOnboardRequestData.supplierName.toLowerCase()) && b.name.toLowerCase().startsWith(this.supplierOnboardRequestData.supplierName.toLowerCase())) return 1;

          return 0;
      };

      this.similarSupplierNames = this.similarSupplierNames.sort(customComparator);
    },
    onSupplierSelected(supplierName){
      this.supplierOnboardRequestData.supplierName = supplierName
      this.resellerValidation()
      this.similarSupplierNames = []
      this.showAllSupplierNames = false
      this.nameFieldEventOccured = false
      this.$refs.supplierAutoComplete.setSupplierNameAndOptions(supplierName)
    },
    toggleShowAllSupplierNames(){
      this.showAllSupplierNames = !this.showAllSupplierNames
    },
    showModelToRedirectToMail(event){
      //clear reseller name if user didn't find the reseller from the list
      this.supplierOnboardRequestData.resellerName="";
      swal
          .fire({
            allowEscapeKey: true,
            showConfirmButton: true,
            showCancelButton: true,
            title: 'A possible new reseller is being requested and will need to be reviewed by Sourcing',
            confirmButtonText: "Re-Direct",
            cancelButtonText: "Go-Back",
            customClass: {
              confirmButton: "flat-btn primary-blue-btn btn mb-1",
              cancelButton: "flat-btn primary-blue-btn cancel-btn btn mb-1"
            },
            html: `Please click on Re-Direct below to SAVE your request as a draft and SUBMIT an email to Sourcing sourcinghub@autodesk.com requesting a reseller onboarding review or click on Go Back to go to the previous page.`,
          })
          .then((result) => {
            if (result.isConfirmed) {
              //save draft
              this.saveSupplierOnboardRequest(true);

              // Redirect to the mailto URL
              window.location.href = `mailto:${CONSTANTS.NEW_RESELLER_MAIL}`;
            }
            //uncheck the box
            event.target.checked=false;
          });
    },
  }
}
</script>

<style scoped>
.preview-notification {
  margin-left: 0;
}

.supplier-name {
  font-weight: bold;
  color: var(--secondary-color);
}

.supplier-name:hover {
  cursor: pointer;
  text-decoration: underline;
}
.title-style{
  width: 200px;
  flex-shrink: 0;
  color: #000;
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
}
</style>

<style scoped src="@/assets/stylesheets/vueSearchSelectOverrides.css">

</style>